// import React, { useEffect, useState } from 'react';
// import { List, ListItem, ListItemText, Badge, Paper } from '@mui/material';
// import "./ChatRoom.scss"
// import ConversationItem from './ConversationItem';
// const ConversationList = ({ currentUser, onSelectConversation, selectedConversation,conversations }) => {
//     const [conversationsCurrent, setCurrentConversations] = useState(conversations || []);

//     useEffect(() => {
    
       
//         const fetchConversations = async () => {
//             const response = await fetch(`${process.env.REACT_APP_API_BASE}/users/${currentUser}/conversations`, {
//       method: 'GET',
//       credentials: 'include', // Ensure session cookies are sent with the request
//     }); 
//             const data = await response.json();
//             console.log('data conversation',data)
//             setCurrentConversations(data);
//         };
//         if(conversations.length===0)
//         {fetchConversations();
//             console.log('current conversationlen 0',conversations)}
//       else{
//         console.log('current conversation',conversations)
//       }
//     }, [currentUser,conversations]);
    
//     return (
//         <Paper elevation={3} className="conversation-list">
//            <List>
//     {conversationsCurrent.length>0 && conversationsCurrent.map(convo => (
//         <ConversationItem
//             key={convo.ConversationId}
//             convo={convo}
//             currentUser={currentUser}
//             selectedConversation={selectedConversation}
//             onSelectConversation={onSelectConversation}
//         />
//     ))}
// </List>
//         </Paper>
//     );
// };

// export default ConversationList;


// ConversationList.jsx
// import React from "react";
// import { List, Paper } from "@mui/material";
// import "./ChatRoom.scss";
// import ConversationItem from "./ConversationItem";

// const ConversationList = ({ currentUser, onSelectConversation, selectedConversation, conversations = [] }) => {
//   const hasItems = Array.isArray(conversations) && conversations.length > 0;

//   return (
//     <Paper elevation={3} className="conversation-list">
//       <List>
//         {!hasItems && <div className="conv-empty">No conversations yet.</div>}
//         {hasItems &&
//           conversations.map((convo) => (
//             <ConversationItem
//               key={convo.ConversationId || convo.id}
//               convo={convo}
//               currentUser={currentUser}
//               selectedConversation={selectedConversation}
//               onSelectConversation={onSelectConversation}
//             />
//           ))}
//       </List>
//     </Paper>
//   );
// };

// export default ConversationList;



import React from "react";
import { List, Paper } from "@mui/material";
import "./ChatRoom.scss";
import ConversationItem from "./ConversationItem";

const ConversationList = ({
  currentUser,
  onSelectConversation,
  selectedConversation,
  conversations = [],
}) => {
  const hasItems = Array.isArray(conversations) && conversations.length > 0;

  return (
    <Paper elevation={3} className="conversation-list">
      <List>
        {!hasItems && (
          <div className="conv-empty">No conversations yet.</div>
        )}

        {hasItems &&
          conversations.map((convo) => (
            <ConversationItem
              key={convo.ConversationId || convo.id}
              convo={convo}
              currentUser={currentUser}
              selectedConversation={selectedConversation}
              onSelectConversation={onSelectConversation}
            />
          ))}
      </List>
    </Paper>
  );
};

export default ConversationList;
